export const workDesc = [
  {
    title: '전문분야',
    workTitle: '민사 | 부동산',
    imgUrl: '/images/work_bg4.jpg',
    work: [
      {
        title: '민사',
        text: '이웃, 거래상대방, 동업자 등과의 일상 생활에서 발생하는 다툼부터 기업사이의 무역관계에 관한 분쟁까지 모두 민사소송 영역입니다. 물품 및 용역대금, 대여금, 채권채무, 각종 계약 및 투자, 경업금지, 사해행위취소, 사고로 인한 손해배상 등에 관한 분쟁, 소송 및 합의에 있어 고객의 요구에 부응하는 결과가 도출될 수 있도록 전문적인 법률서비스를 제공하고 있습니다.',
      },
      {
        title: '부동산',
        text: '주택, 아파트, 상가 등 부동산에 관한 매매/임대차/상가양도(권리금)분쟁, 부동산명도, 기획부동산, 토지수용보상, 공사대금, 건축하자 등 부동산 건축에 관하여 다양한 분쟁이 일어납니다. 복잡하고 까다로운 부동산/건설 분쟁에 관하여 다년간의 경험과 노하우를 바탕으로 고객의 입장에서 법률서비스를 제공하고 있습니다.',
      },
    ],
  },
  {
    workTitle: '이혼 | 가사 | 상속',
    imgUrl: '/images/work_bg3.jpg',
    work: [
      {
        title: '이혼',
        text: '이혼을 잘 다루는 변호사는 따로 있습니다. 수년간 매년 100건 이상의 이혼 관련 사건을 진행하면서 쌓아온 실무 경험을 토대로 의뢰인의 손과 발이 되어드립니다. 의뢰인의 이익은 물론 상처받은 마음까지 헤아려 업무를 진행합니다. 재산분할, 위자료, 상간자 손해배상, 양육권, 면접교섭 등에 관하여 사실혼해소, 협의이혼, 조정이혼, 재판상이혼 등 모든 영역에 풍부한 경험을 자랑합니다.',
      },
      {
        title: '가사',
        text: '이혼, 상속 외에도 입양, 친권, 후견, 친자관계부인, 친생부인 등에 관한 다양한 가사문제에 관하여 유기적인 해법을 제시합니다. 사건 끝까지 의뢰인과 지속적으로 소통하며 풍부한 경험을 바탕으로 체계적인 서비스를 제공하고 있습니다.',
      },
      {
        title: '상속',
        text: '상속 재산을 분할하는 방법으로는 사망자의 생전증여나 유언에 의한 분할, 상속인들 사이의 협의에 의한 분할 등이 있습니다. 그러나 공동상속인들끼리 협의가 되지 않거나, 사망자의 생전증여 등이 상속인의 유류분을 침해하는 경우 소송, 조정 등을 통해 분할해야 합니다. 상속재산보다 상속채무가 많은 경우에는 상속포기, 한정승인, 특별한정승인 등을 통하여 그 책임을 면할 수 있습니다.',
      },
    ],
  },
  {
    workTitle: '형사 | 성범죄',
    imgUrl: '/images/work_bg2.jpg',
    work: [
      {
        title: '형사',
        text: '보이스피싱, 성범죄, 군인공무원범죄, 명예훼손, 업무방해, 마약, 도박, 사기, 횡령, 절도, 강도, 교통사고 등 형사 사건 전반에 관하여 풍부한 경험을 자랑합니다.피해자에게는 시기적절한 조력을 통하여 피해자의 아픔을 위로하고 권리를 찾을 수 있도록 도와드립니다.억울한 누명을 쓴 분들에게는 적극적인 법적 방어를 통하여 불리한 상황에서도 타개책을 찾도록 도와드립니다.',
      },
      {
        title: '성범죄',
        text: '성추행, 성폭행(강간), 성희롱, 아청법위반, 성매매, 불법촬영, 불법촬영물유포 등 성범죄에 관하여 다양하고 풍부한 실무경험을 바탕으로 해결법을 마련하고 있습니다.의뢰인의 권익보호와 인권침해 방지를 위하여 노력하며, 항상 의뢰인의 상황에 맞추어 적합한 해결책을 찾고 있습니다.',
      },
    ],
  },
  {
    workTitle: '노동 | 공정거래',
    imgUrl: '/images/work_bg1.jpg',
    work: [
      {
        title: '노동',
        text: '법률사무소 훈의 변호사와 노무사들은 노동 분쟁 및 컨설팅에 풍부한 경험을 가지고 있습니다. 변호사와 노무사들이 협업을 통해 노동청, 노동위원회, 검찰청, 법원의 모든 과정에 대한 원스톱 서비스를 제공합니다. 이성적인 시각으로 접근하되, 언제나 고객의 입장에서 최선의 해법을 제시합니다.',
      },
      {
        title: '공정거래',
        text: '공정거래 부정경쟁방지 저작권 등 기업법무 빠른속도로 발전하는 각 산업영역에 맞추어, 법률사무소 훈은 ‘고객중심’이라는 일념하에 기업경영의 좋은 친구가 되어드립니다.공정거래, 부정경쟁방지, 저작권 침해 등 기업이 당면하게 되는 각종 법률 이슈에 대한 맞춤형 종합법률서비스를 제공하고 있습니다. 다양한 규모의 기업들을 대상으로 기업의 설립단계부터 지배구조, 각종 규제대응, 지식재산권보호, 개인정보보호, 투자관련 자문 등에 관하여 풍부한 경험과 기업에 대한 높은 이해도를 지닌 전문가들이 고품질의 서비스를 제공하고 있습니다.',
      },
    ],
  },
];
